module.exports = __webpack_public_path__ + "img/_DSC1314.8e996181.jpg";